import { render } from "./CorporateDashboard.vue?vue&type=template&id=25bfa3f4&scoped=true"
import script from "./CorporateDashboard.vue?vue&type=script&lang=js"
export * from "./CorporateDashboard.vue?vue&type=script&lang=js"

import "./CorporateDashboard.vue?vue&type=style&index=0&id=25bfa3f4&lang=css"
import "./CorporateDashboard.vue?vue&type=style&index=1&id=25bfa3f4&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bfa3f4"]])

export default __exports__